export default "__VITE_ASSET__CM4IbCqG__"